<template>
  <div class="detail-list-ctx">
    <ul class="detail-list">
      <li
          class="detail-list-item"
          :class="{'full-row': full || val.full, vertical: val.vertical}"
          v-for="val in detailList" :key="val.key">
        <div class="detail-list-label">{{val.label}}</div>
        <div class="detail-list-value" v-if="val.scopedSlot">
          <slot :name="val.scopedSlot" v-bind:value="val.value"></slot>
        </div>
        <div class="detail-list-value" v-else-if="val.imgList">
          <div class="file-list" v-if="val.imgList.length > 0">
            <img class="file-item" :src="f" v-for="(f, i) in val.imgList" :key="i">
          </div>
          <div v-else>无</div>
        </div>
        <div class="detail-list-value" v-else-if="val.file">
          <div class="simple-file-list" v-if="val.value && val.value.length > 0">
            <div class="simple-file-item" v-for="(f, i) in val.value" :key="i">
              <img class="simple-file-img" :src="f.url" v-if="f.type == 'image'">
              <img class="simple-file-img" :src="require(`../assets/file/${f.type}.png`)" v-else>
              <div class="simple-file-name">{{f.fileName}}</div>
            </div>
          </div>
          <div v-else>无</div>
        </div>
        <div class="detail-list-value" v-else-if="val.textarea">
          <article v-if="val.value">
            <p class="detail-list-p" v-for="(p, i) in val.value.split(/\r|\n/)" :key="i">{{p}}</p>
          </article>
          <span v-else>无</span>
        </div>
        <div class="detail-list-value" v-else-if="val.rich">
          <div class="rich-preview" v-html="val.value" v-if="val.value"></div>
          <span v-else>无</span>
        </div>
        <div class="detail-list-value" v-else>{{val.value || '无'}}</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "DetailList",
  props: {
    list: Array,
    full: Boolean
  },
  computed: {
    detailList() {
      let list = this.list;
      list.forEach(item => {
        if(item.rich || item.textarea || item.imgList) {
          item.full = true;
          // item.vertical = true;
        }
      })
      return list;
    }
  }
}
</script>

<style scoped lang="less">
.detail-list {
  font-size: 0;
}
.detail-list-item {
  display: inline-flex;
  width: 50%;
  padding: 6px 0;
  background-color: @component-background;
  line-height: 1.4;
  font-size: 14px;
  &.vertical {
    flex-direction: column;
    .detail-list-value {
      margin: 10px 0 0;
    }
  }
  &.full-row {
    width: 100%;
  }
  .rich-preview {
    width: 484px;
  }
}
.detail-list-label {
  min-width: 120px;
  color: @text-color-secondary;
}
.detail-list-value {
  margin-left: 20px;
  color: @text-color;
  text-align: justify;
}
.detail-list-p {
  margin-bottom: 0;
  line-height: 1.5;
}
.simple-file-list {
  display: flex;
  align-items: center;
  margin: -10px;
}
.simple-file-item {
  display: inline-flex;
  align-items: center;
  padding: 10px;
}
.simple-file-img {
  width: 22px;
  height: 22px;
}
.simple-file-name {
  margin-left: 8px;
}

</style>
